import { useRef, useEffect } from 'react';

/**
 * Custom hook to track whether a component is still mounted.
 * Returns a ref object with a `current` property that is `true`
 * if the component is mounted, and `false` otherwise.
 */
export function useIsMounted() {
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
